var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeauturedIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#191919"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 23.6667L35.5898 33.5626C35.4149 33.7403 35.3264 33.8294 35.248 33.8995C33.9824 35.0323 32.0687 35.0323 30.8031 33.8995C30.7247 33.8294 30.6356 33.7404 30.4605 33.5626C30.2854 33.3847 30.1978 33.2958 30.1195 33.2257C28.8539 32.0929 26.9393 32.0929 25.6737 33.2257C25.5955 33.2956 25.5082 33.3843 25.334 33.5613L18.666 40.3334M45.3334 23.6667L45.3327 33.6667M45.3334 23.6667H35.3327",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeauturedIcon2);
export default __webpack_public_path__ + "static/media/feauturedIcon2.000b3f369b67860d2f86947803084745.svg";
export { ForwardRef as ReactComponent };